<div class='progress-bar'>
    <mat-progress-bar [value]="value">
        <ng-content></ng-content>
    </mat-progress-bar>
  </div>